import React from 'react';
import ReactDOM from 'react-dom/client';
// Primero: Design system base
import './styles/design-system.css';
import './styles/components-optimized.css';
import './styles/font-optimization.css';

// Luego: Estilos específicos de componentes
import './styles/index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Kill-switch de Service Workers y caches antiguos (evita modo offline inesperado)
// Seguro mantenerlo: si no hay SW registrados, no hace nada.
// Ejecuta una vez por carga y limpia caches típicas de CRA/Workbox.
(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => reg.unregister());
    });
  }
  if (window.caches && window.caches.keys) {
    caches.keys().then((keys) => {
      keys
        .filter((k) =>
          /workbox|^precache-|^webpack|^runtime|^static-cache/i.test(k)
        )
        .forEach((k) => caches.delete(k));
    });
  }
  // También forzamos recarga de recursos si el navegador estaba en estado offline cacheado
  if (typeof window !== 'undefined') {
    // Ayuda a invalidar recursos cacheados por SW anteriores en navegadores que respeten cache-control
    const stamp = Date.now();
    const links = document.querySelectorAll(
      'link[rel="stylesheet"], script[src]'
    );
    links.forEach((el) => {
      const attr = el.tagName === 'LINK' ? 'href' : 'src';
      const url = new URL(el.getAttribute(attr), window.location.href);
      url.searchParams.set('v', stamp);
      el.setAttribute(attr, url.toString());
    });
    // Aviso en consola
    // eslint-disable-next-line no-console
    console.info(
      '[SW cleanup] Service workers desregistrados y caches limpiadas'
    );
  }
})();
